import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_story.less'
import TipBox from 'components/common/tip_box'
import { getI18n } from 'client/i18n'
import { domOnlyProps } from 'lib/form_utils'
import { getFormError } from 'lib/validators'
import {
  DESCRIPTION_ROWS,
  CROWDFUNDING_DESCRIPTION_LENGTH,
} from 'shared/lengths'
import { BodyText, Button, HeadingText, TextArea } from '@paypalcorp/pp-react'
import { trackEventNameClick } from 'lib/fpti_analytics'
import clsx from 'clsx'
import { Message } from '@paypalcorp/worldready-react'
import { POOL_TYPE } from 'shared/shared_consts'
import Private from './partials/private'

export const I18N_CONTEXT = 'components/pages/crowdfunding/pool_story'
const i18n = getI18n(I18N_CONTEXT)

class PoolDescription extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    shouldAutoFocus: PropTypes.bool,
    onChangeCover: PropTypes.func,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    npid: PropTypes.string,
    charity: PropTypes.object,
    initializeForm: PropTypes.func,
    description: PropTypes.string,
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func,
    type: PropTypes.string,
  }

  state = {
    charCount: 0,
  }

  componentDidMount() {
    const { initializeForm, description } = this.props
    initializeForm({
      description,
    })
  }

  handleNextClick = () => {
    const eventName = 'dw_giving_fundraiser_select_photo_screen_shown'
    trackEventNameClick({
      event_name: eventName,
    })
    trackEventNameClick({
      event_name: 'dw_giving_fundraiser_tell_story_next_pressed',
    })
  }

  render() {
    const {
      fields: { description },
      handleSubmit,
      anyInactiveFieldsTouchedWithError,
      type,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        {type === POOL_TYPE.PRIVATE ? (
          <Private description={description} />
        ) : (
          <>
            <HeadingText size="sm" styleName="form__title">
              <Message id="components.pages.crowdfunding.pool_story.title" />
            </HeadingText>
            <BodyText styleName="form__subtitle">
              <Message id="components.pages.crowdfunding.pool_story.subtitle" />
            </BodyText>

            <TextArea
              {...domOnlyProps(description)}
              data-nemo="about-pool-description"
              minRows={DESCRIPTION_ROWS}
              label={i18n('description_title')}
              showCharacterCounter={true}
              maxCharacters={CROWDFUNDING_DESCRIPTION_LENGTH}
              errorText={getFormError(description)}
              data-testid="story-description"
            />

            <TipBox text={i18n('tip_description')} type="story" />
          </>
        )}

        <div styleName="form__button">
          <Button
            className={clsx({
              'vx_btn-disabled': anyInactiveFieldsTouchedWithError,
            })}
            disabled={anyInactiveFieldsTouchedWithError}
            data-nemo="description_next"
            onClick={this.handleNextClick}
            data-testid="story-btn-next"
          >
            {i18n('next')}
          </Button>
        </div>
      </form>
    )
  }
}

export default cssModules(PoolDescription, styles)
